import React, {useState} from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {ClipLoader} from 'react-spinners';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectEmail} from '../../slices/auth';
import {sendMessage, updateGameWinners} from '../../api/company';

export const MessageToWinners = ({winners, game}) => {
    const {register, handleSubmit} = useForm({
        defaultValues: {
            message: "",
        }
    });
    const dispatch = useDispatch();
    const email = useSelector(selectEmail);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    const onSave = async (form) => {
        try {
            setLoading(true);
            dispatch(openAlert({type: "info", message: t("alert_wait")}))
            // set winner
            await updateGameWinners(winners.map(w => w.info.uid), game);

            //send message
            if (form.message) {
                await sendMessage([...winners.map(w => w.info.email)], form.message, email);
            }

            setLoading(false);
            dispatch(openAlert({type: "success", message: t("alert_msg_sent")}))
            dispatch(closeDialog());
        } catch (error) {
            setLoading(false);
            dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
        }
    }

    return (
        <div className="messageToWinner">
            {!loading && <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_setGameWinner_msg_label")}</div>
                    <textarea
                        name="message"
                        placeholder={t("company_rm_setGameWinner_msg_ph")}
                        ref={register()}
                        rows="10"
                    />
                </div>
                <input type="submit" value={t("company_rm_setGameWinner_submit")}/>
            </form>}
            {loading && <div className="loader">
                <ClipLoader size={20} color={"#7400b8"} loading={true}/>
            </div>}
        </div>
    )
}
